module.exports = __webpack_public_path__ + "static/media/sarkar-logo.341add2e.png";